// extracted by mini-css-extract-plugin
module.exports = {"card":"CommentCard_card__3THK8","icon":"CommentCard_icon__BXYKM","typeContainer":"CommentCard_typeContainer__Vf1cG"};